'use client';
import styled from 'styled-components';

export const StyledRecipeNutrient = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;
